<template>
  <div class="con">
    <!-- 头部 -->
    <headbox></headbox>

    <about></about>
    <!-- 公司介绍 -->
    <!-- 底部 -->
    <footbox></footbox>
  </div>
</template>

<script>
import headbox from './components/home/headbox' 
import about from './components/about/about' 


import footbox from './components/footbox'
export default {
  components: {
    headbox,
    footbox,
    about
  },
  data () {
    return {
    };
  },
  methods: {
  }
};
</script>

<style lang="less" scoped>
</style>
